/**
 * Chevron Left Icon - Left-pointing chevron for navigation
 *
 * Design: 16x16 bold chevron pointing left
 * Usage: Lightbox prev button, carousel navigation
 * Color: Inherits from parent (uses currentColor)
 */

export const ChevronLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 2L4.5 8L10.5 14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
